import React, { useState } from "react";
import {
  Image,
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  useWindowDimensions,
  View,
} from "react-native";
import get from "lodash/get";
import { FontFamily } from "../../styles/appStyles";

function openUrl(url) {
  if (url) {
    Linking.openURL(url);
  }
}

const ANDROID_APP_URL =
  "https://play.google.com/store/apps/details?id=com.app.themorningcontext";
const IOS_APP_URL =
  "https://apps.apple.com/in/app/the-morning-context/id1551672701";

function AndroidIcon() {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.376084 0.962891C0.205349 1.13363 0.148438 1.41818 0.148438 1.75965V14.3371C0.148438 14.6786 0.262261 14.9632 0.432996 15.1339L0.489908 15.1908L7.54695 8.13376V8.01994L0.376084 0.962891Z"
        fill="url(#paint0_linear_2593_78078)"
      ></path>
      <path
        d="M9.82361 10.523L7.49023 8.18966V8.01892L9.82361 5.68555L9.88052 5.74246L12.6692 7.33599C13.466 7.79128 13.466 8.53113 12.6692 8.98642L9.82361 10.523Z"
        fill="url(#paint1_linear_2593_78078)"
      ></path>
      <path
        d="M9.88022 10.4665L7.48993 8.07617L0.375977 15.1901C0.660535 15.4747 1.05892 15.4747 1.57112 15.247L9.88022 10.4665Z"
        fill="url(#paint2_linear_2593_78078)"
      ></path>
      <path
        d="M9.87925 5.68614L1.57014 0.962474C1.05794 0.677915 0.659558 0.734827 0.375 1.01939L7.48896 8.07643L9.87925 5.68614Z"
        fill="url(#paint3_linear_2593_78078)"
      ></path>
      <path
        opacity="0.2"
        d="M9.82233 10.4092L1.57014 15.0759C1.11485 15.3605 0.71647 15.3036 0.431912 15.0759L0.375 15.1328L0.431912 15.1898C0.71647 15.4174 1.11485 15.4743 1.57014 15.1898L9.82233 10.4092Z"
        fill="black"
      ></path>
      <path
        opacity="0.12"
        d="M0.376084 15.0763C0.205349 14.9056 0.148438 14.621 0.148438 14.2795V14.3365C0.148438 14.6779 0.262261 14.9625 0.432996 15.1332V15.0763H0.376084ZM12.669 8.81602L9.82342 10.4095L9.88033 10.4665L12.669 8.87293C13.0674 8.64529 13.2381 8.36073 13.2381 8.07617C13.2381 8.36073 13.0105 8.58838 12.669 8.81602Z"
        fill="black"
      ></path>
      <path
        opacity="0.25"
        d="M1.57123 1.01942L12.669 7.33661C13.0105 7.56426 13.2381 7.79191 13.2381 8.07646C13.2381 7.79191 13.0674 7.50735 12.669 7.2797L1.57123 0.962508C0.774466 0.507215 0.148438 0.848685 0.148438 1.75927V1.81618C0.148438 0.962508 0.774466 0.564127 1.57123 1.01942Z"
        fill="white"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_2593_78078"
          x1="6.86401"
          y1="1.65152"
          x2="-2.68747"
          y2="11.2024"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00A0FF"></stop>
          <stop offset="0.007" stop-color="#00A1FF"></stop>
          <stop offset="0.26" stop-color="#00BEFF"></stop>
          <stop offset="0.512" stop-color="#00D2FF"></stop>
          <stop offset="0.76" stop-color="#00DFFF"></stop>
          <stop offset="1" stop-color="#00E3FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_2593_78078"
          x1="13.713"
          y1="8.07641"
          x2="-0.0579566"
          y2="8.07641"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE000"></stop>
          <stop offset="0.409" stop-color="#FFBD00"></stop>
          <stop offset="0.775" stop-color="#FFA500"></stop>
          <stop offset="1" stop-color="#FF9C00"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_2593_78078"
          x1="8.58662"
          y1="9.38286"
          x2="-4.36533"
          y2="22.3348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF3A44"></stop>
          <stop offset="1" stop-color="#C31162"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_2593_78078"
          x1="-1.39097"
          y1="-3.20574"
          x2="4.39296"
          y2="2.5782"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#32A071"></stop>
          <stop offset="0.069" stop-color="#2DA771"></stop>
          <stop offset="0.476" stop-color="#15CF74"></stop>
          <stop offset="0.801" stop-color="#06E775"></stop>
          <stop offset="1" stop-color="#00F076"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.65759 4.81441C6.07359 4.81441 5.16958 4.15041 4.21758 4.17441C2.96158 4.19041 1.80958 4.90241 1.16158 6.03041C-0.142422 8.29441 0.825578 11.6384 2.09758 13.4784C2.72158 14.3744 3.45758 15.3824 4.43358 15.3504C5.36958 15.3104 5.72159 14.7424 6.85759 14.7424C7.98559 14.7424 8.30559 15.3504 9.29759 15.3264C10.3056 15.3104 10.9456 14.4144 11.5616 13.5104C12.2736 12.4704 12.5696 11.4624 12.5856 11.4064C12.5616 11.3984 10.6256 10.6544 10.6016 8.41441C10.5856 6.54241 12.1296 5.64641 12.2016 5.60641C11.3216 4.31841 9.96959 4.17441 9.49759 4.14241C8.26559 4.04641 7.23359 4.81441 6.65759 4.81441ZM8.73759 2.92641C9.25759 2.30241 9.60159 1.43041 9.50559 0.566406C8.76159 0.598406 7.86559 1.06241 7.32959 1.68641C6.84959 2.23841 6.43359 3.12641 6.54559 3.97441C7.36959 4.03841 8.21759 3.55041 8.73759 2.92641Z"
        fill="#321F1F"
      ></path>
    </svg>
  );
}

const SocialLinks = ({ footerData }) => {
  const [hoveredLink, setHoveredLink] = useState(null);
  const { width } = useWindowDimensions();
  const isLg = width >= 1024;
  const socialLinks = get(footerData, "social_links") || [];
  const sections = get(footerData, "sections") || [];
  const lastSection = sections.slice(-1);
  const lastSectionLinks = [
    ...(lastSection[0]?.links || []),
    { name: "Help", url: "mailto:support@slowform.com" },
  ];
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "";
  const isMiddleEast = pathname?.includes("/middle-east");

  return (
    <View style={styles.wrapper}>
      <View style={styles.container}>
        <View style={styles.divider} />

        <View style={[styles.content, isLg && styles.contentLg]}>
          <View style={[styles.linkList, isLg && styles.linkListLg]}>
            {lastSectionLinks.map((item) => {
              const isSlowformLink = item.name.includes("Slowform");

              return (
                <TouchableOpacity
                  activeOpacity={0.8}
                  disabled={isSlowformLink}
                  key={item.name}
                  onMouseEnter={() => {
                    if (!isSlowformLink) {
                      setHoveredLink(item.name);
                    }
                  }}
                  onMouseLeave={() => setHoveredLink(null)}
                  onPress={() => openUrl(item.url)}
                >
                  <Text
                    style={[
                      styles.footerLink,
                      hoveredLink === item.name && styles.footerLinkHover,
                    ]}
                  >
                    {item.name}
                  </Text>
                </TouchableOpacity>
              );
            })}
          </View>

          <View style={styles.actions}>
            <View style={styles.appStoreList}>
              <TouchableOpacity
                activeOpacity={0.8}
                style={styles.appStoreButton}
                onPress={() => window.open(ANDROID_APP_URL, "_blank")}
              >
                <AndroidIcon />
                <Text style={styles.appStoreText}>Android</Text>
              </TouchableOpacity>
              <TouchableOpacity
                activeOpacity={0.8}
                style={styles.appStoreButton}
                onPress={() => window.open(IOS_APP_URL, "_blank")}
              >
                <AppleIcon />
                <Text style={styles.appStoreText}>Apple</Text>
              </TouchableOpacity>
            </View>
            <View style={styles.socialList}>
              {socialLinks.map((item) => (
                <TouchableOpacity
                  activeOpacity={0.8}
                  key={item.title}
                  onPress={() => window.open(item.url, "_blank")}
                  style={styles.socialLink}
                >
                  <Image
                    resizeMode="contain"
                    source={{ uri: item.image }}
                    style={styles.socialIcon}
                  />
                </TouchableOpacity>
              ))}
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: "#f3eee2",
    paddingBottom: 32,
  },
  container: {
    alignSelf: "center",
    maxWidth: 1440,
    paddingHorizontal: 24,
    width: "100%",
  },
  divider: {
    borderTopColor: "#D8D0C1",
    borderTopWidth: 1,
  },
  content: {
    alignItems: "flex-start",
    flexDirection: "column",
    gap: 16,
    justifyContent: "flex-start",
    paddingTop: 16,
  },
  contentLg: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  linkList: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
  },
  linkListLg: {
    gap: 32,
  },
  footerLink: {
    color: "#8f897b",
    fontFamily: FontFamily.interRegular,
    fontSize: 12.8,
    lineHeight: 17.92,
  },
  footerLinkHover: {
    color: "#0f9e7a",
    textDecorationLine: "underline",
  },
  actions: {
    alignItems: "center",
    flexDirection: "row",
    gap: 8,
  },
  socialList: {
    alignItems: "center",
    flexDirection: "row",
    gap: 8,
  },
  socialLink: {
    alignItems: "center",
    borderColor: "#D8D0C1",
    borderRadius: 999,
    borderWidth: 1,
    height: 35,
    justifyContent: "center",
    width: 35,
  },
  appStoreList: {
    flexDirection: "row",
    gap: 8,
  },
  appStoreButton: {
    alignItems: "center",
    borderColor: "#321f1f29",
    borderRadius: 2,
    borderWidth: 1,
    flexDirection: "row",
    gap: 5,
    height: 35,
    justifyContent: "center",
    paddingHorizontal: 12,
  },
  appStoreText: {
    color: "#2c2a24",
    fontFamily: FontFamily.interRegular,
    fontSize: 13.6,
    fontWeight: "400",
  },
  socialIcon: {
    height: 20,
    width: 20,
  },
});

export default SocialLinks;
